module.exports = __webpack_public_path__ + "img/zoho.3da32826.png";